import React from 'react';
import PriceAlertInterface from 'modules/price-alert/price-alert.interface';

interface ProductPriceHistoryContextInterface {
    onSubmit: (data: PriceAlertInterface) => void;
}

const ProductPriceHistoryContext = React.createContext<ProductPriceHistoryContextInterface>({
    onSubmit: () => {
        throw new Error('Invalid data format');
    }
});

export default ProductPriceHistoryContext;
